import { VehicleType, } from "./enums";
export const mapFormData = (form) => {
    const applicant = mapApplicant(form);
    const hasCoApp = form.AddCoApp.checked;
    const coApp = hasCoApp ? mapApplicant(form, true) : undefined;
    const vehicle = mapVehicle(form);
    const bac = form.BAC.value;
    const parentSiteUrl = form.ParentSiteUrl.value;
    return {
        BACCode: bac,
        Applicant: applicant,
        CoApplicant: coApp,
        Vehicle: vehicle,
        Metadata: {
            ParentSiteUrl: parentSiteUrl,
        },
    };
};
const mapAdditionalIncome = (form, prefix) => {
    const source = form[`${prefix}AdditionalIncomeSource`].value.trim();
    const basis = form[`${prefix}AdditionalIncomeBasis`]
        .value;
    const income = parseInt(form[`${prefix}AdditionalIncome`].value);
    const duration = parseInt(form[`${prefix}AdditionalIncomeDuration`].value);
    const years = Math.floor(duration / 12);
    const months = duration % 12;
    return {
        Source: source,
        DurationYears: years,
        DurationMonths: months,
        IncomeBasis: basis,
        IncomeAmount: income,
    };
};
const mapAddress = (form, prefix) => {
    const str1 = form[`${prefix}StreetAddress1`].value.trim();
    if (str1 === "") {
        return undefined;
    }
    const str2 = form[`${prefix}StreetAddress2`].value.trim();
    const city = form[`${prefix}City`].value.trim();
    const state = form[`${prefix}State`].value;
    const zip = form[`${prefix}Zip`].value;
    const resType = form[`${prefix}ResidenceType`]
        .value;
    const resDuration = parseInt(form[`${prefix}ResidenceDuration`].value);
    const rent = parseInt(form[`${prefix}MonthlyRent`].value);
    return {
        StreetAddress1: str1,
        StreetAddress2: str2,
        City: city,
        State: state,
        Zip: zip,
        ResidenceType: resType,
        DurationYears: resDuration,
        DurationMonths: 0,
        MonthlyRent: rent,
    };
};
const mapEmployment = (form, prefix) => {
    const status = form[`${prefix}EmploymentStatus`].value;
    if (status === "") {
        return undefined;
    }
    const jobTitle = form[`${prefix}JobTitle`].value.trim();
    const empName = form[`${prefix}EmployerName`].value.trim();
    const empPhone = form[`${prefix}EmployerPhoneNumber`].value.replace(/[^\d]/g, "");
    const basis = form[`${prefix}IncomeBasis`].value;
    const income = parseInt(form[`${prefix}Income`].value);
    const duration = parseInt(form[`${prefix}EmploymentDuration`].value);
    const years = Math.floor(duration / 12);
    const months = duration % 12;
    const addIncomeBox = form[`${prefix}AddIncome`];
    const additional = addIncomeBox.checked
        ? mapAdditionalIncome(form, prefix)
        : undefined;
    return {
        Status: status,
        JobTitle: jobTitle,
        EmployerName: empName,
        EmployerPhoneNumber: empPhone,
        DurationYears: years,
        DurationMonths: months,
        IncomeBasis: basis,
        IncomeAmount: income,
        AdditionalIncome: additional,
    };
};
const mapApplicant = (form, isCoApp = false) => {
    const prefix = isCoApp ? "CoApp" : "";
    const first = form[`${prefix}FirstName`].value.trim();
    const last = form[`${prefix}LastName`].value.trim();
    const suffix = form[`${prefix}Suffix`].value;
    const email = form[`${prefix}Email`].value;
    const phone = form[`${prefix}PhoneNumber`].value.replace(/[^\d]/g, "");
    const taxId = form[`${prefix}TaxID`].value.replace(/[^\d]/g, "");
    const dobField = form.querySelector(`input[name='${prefix}DateOfBirth']`);
    const dob = dobField ? dobField.value : null;
    const address = mapAddress(form, prefix);
    const prevAddress = address.DurationYears < 2
        ? mapAddress(form, isCoApp ? "CoAppPrev" : "Prev")
        : undefined;
    const employment = mapEmployment(form, prefix);
    const prevEmployment = employment.DurationYears < 2
        ? mapEmployment(form, isCoApp ? "CoAppPrev" : "Prev")
        : undefined;
    return {
        FirstName: first,
        LastName: last,
        Suffix: suffix,
        Email: email,
        PhoneNumber: phone,
        DateOfBirth: dob,
        TaxID: taxId,
        Address: address,
        PrevAddress: prevAddress,
        Employment: employment,
        PrevEmployment: prevEmployment,
    };
};
const mapVehicle = (form) => {
    const year = parseInt(form.VehicleYear.value);
    const brand = form.VehicleMake.value;
    const model = form.VehicleModel.value;
    const selectedTypeRadio = form.querySelector("[name='VehicleType']:checked");
    let type;
    switch (selectedTypeRadio.value) {
        case "U":
            type = VehicleType.Used;
            break;
        case "true":
            type = VehicleType.Cpo;
            break;
        default:
            type = VehicleType.New;
    }
    return {
        VehicleType: type,
        Brand: brand === "" ? undefined : brand,
        Model: model === "" ? undefined : model,
        Year: year === 0 ? undefined : year,
    };
};
